module.exports = {
	"account.user.driving.licence.already.exist": "Istnieje inne konto z tym numerem prawa jazdy.",
	"account.user.login.already.exist": "Ten adres e-mail jest już używany przez inne konto.",
	"account.user.suspended": "Nie można wykonać tej czynności, ponieważ użytkownik jest zawieszony",
	"action.add.payment": "Dodaj metodę płatności",
	"action.complete.my.account": "Uzupełnij moje konto",
	"action.confirm.welcome.msg": "Chodźmy",
	"action.create.my.account": "Utwórz konto",
	"action.search.update.bookings": "Sprawdź dostępność",
	"action.update.payment": "Zaktualizuj metodę płatności",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Klikając „Potwierdź”, oświadczasz, że zgadzasz się z regulaminem i korzystając z usługi car-sharingu, masz ważne prawo jazdy. Więcej w {link}.",
	"booking.accept_usage_terms.title": "Regulamin",
	"booking.action.cancel.forbidden": "Nie możesz już anulować rezerwacji",
	"booking.action.edit.forbidden": "Nie możesz już edytować rezerwacji",
	"booking.add.calendar": "Dodaj do kalendarza",
	"booking.confirm": "Potwierdź rezerwację",
	"booking.confirm_and_pay": "Potwierdź i zapłać",
	"booking.deposit": "Kaucja",
	"booking.deposit.b": "Depozyt bankowy w wysokości {damageSafetyDeposit} {currency} zostanie pobrany po potwierdzeniu rezerwacji.\n Depozyt ten może zostać wykorzystany na pokrycie wszelkich szkód wyrządzonych w pojeździe podczas podróży. \n\n Jeśli pojazd zostanie zwrócony bez uszkodzeń lub nadgodzin, zostanie naliczona {bookingPrice} {currency}",
	"booking.deposit.d": "Po potwierdzeniu rezerwacji zostanie dokonany depozyt bankowy w wysokości {bufferPrice} {currency}\n Obejmuje to cenę rezerwacji i opłatę za pokrycie wszelkich przekroczeń. \n\n Bez przekroczenia pojazdu lub uszkodzenia pojazdu tylko {bookingPrice} {currency} zostanie pobrane z Twojego konta.",
	"booking.deposit.db": "Po potwierdzeniu rezerwacji zostaną naliczone dwa depozyty bankowe:\n — Pierwsza w wysokości {bufferPrice} {currency} , w tym cena rezerwacji i opłata za wszelkie przekroczenia.\n — Drugi w kwocie {damageSafetyDeposit} {currency} na pokrycie wszelkich szkód wyrządzonych w pojeździe podczas rezerwacji. \n\n Bez przekroczenia lub uszkodzenia pojazdu, zostanie obciążona {bookingPrice} {currency}",
	"booking.deposit.info": "Za rezerwację zostanie wpłacona kaucja",
	"booking.payment.prebilling.refused.error": "Transakcja została odrzucona, ponieważ obciążenie Twojej karty kredytowej nie powiodło się. Ponów próbę z inną kartą. Jeśli problem nie ustąpi, skontaktuj się z bankiem.",
	"booking.payment.prebilling.technical.error": "Wystąpił błąd podczas dokonywania płatności. Spróbuj ponownie później.",
	"booking.success.sub.title": "Dziękujemy za skorzystanie z naszych usług!",
	"booking.success.title": "Gratulujemy, Twoja rezerwacja została pomyślnie utworzona!",
	"booking.type.label": "Typ rezerwacji",
	"booking.type.one_way": "W jedną stronę",
	"booking.type.return_trip": "Podróż powrotna",
	"booking.update.period.expired": "Upłynął okres aktualizacji dat rezerwacji",
	"booking.usage.business": "Dla firm",
	"booking.usage.private": "Dla osób fizycznych",
	"booking.view_payment_terms.title": "Warunki płatności",
	"booking.voucher.different.code": "Nie możesz zmienić swojego kodu promocyjnego",
	"booking.voucher.placeholder": "Mam kod kuponu",
	"car.AUTOMATIC": "Automatyczna",
	"car.DIESEL": "Wysokoprężny",
	"car.ELECTRIC": "Elektryczny",
	"car.FOLDING_SEATS": "Składane siedzenia",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrydowy",
	"car.LPG": "GPL",
	"car.MANUAL": "Ręczna",
	"car.PETROL": "Benzynowy",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Szczegóły rezerwacji",
	"car.color": "Kolor",
	"car.compact_cars": "Kompaktowy",
	"car.description": "Description",
	"car.details": "Dane pojazdu",
	"car.doors": "Liczba drzwi",
	"car.filter.COMMERCIAL": "Samochód dostawczy",
	"car.filter.PASSENGER": "Turystyka",
	"car.filter.accessories.air_conditioning": "Klimatyzacja",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Duża ciężarówka",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Liczba osób",
	"car.filter.other": "Inne",
	"car.filter.other-nb": "Inne - {nb}",
	"car.filter.vehicle_type": "Typ pojazdu",
	"car.filter_energy": "Energia",
	"car.filter_gearbox_type": "Typ skrzyni biegów",
	"car.filter_persons": "ludzie",
	"car.for_every_additional_km": "Za dodatkowy kilometr",
	"car.km_included": "KM wliczone w cenę",
	"car.motorization": "Napęd",
	"car.options": "Wyposażenie",
	"car.parking_additional_info": "Szczegółowe informacje dotyczące parkowania",
	"car.places": "Miejsca",
	"car.pricing": "Ceny",
	"car.pricing.estimate": "Szacunkowa cena",
	"car.pricing.extra_km_cost_per_day": "Cena dodatkowych kilometrów",
	"car.pricing.free_km_per_day": "Kilometry / 24 h",
	"car.specifications": "Dane techniczne",
	"car.transmission": "Skrzynia biegów",
	"car.utility_cars": "Użytkowy",
	"car.version": "Wersja",
	"company.id.missing.booking.search": "Identyfikator firmy jest wymagany do anonimowego wyszukiwania rezerwacji",
	"contact_page.phone_call_price": "(BEZPŁATNE POŁĄCZENIE Z TELEFONU STACJONARNEGO)",
	"contact_page.title_1": "W przypadku jakichkolwiek pytań dotyczących wynajmu samochodu,",
	"contact_page.title_2": "bez obaw skontaktuj się z nami przez e-mail.",
	"creditcard.data.insufficient.3ds": "Ze względu na nowe wymagania dotyczące 3DS2 prosimy o zaktualizowanie informacji o płatności.",
	"custom.field.type.boolean": "Tak/Nie",
	"data.with.colon": "{data}:",
	"document.issue.date": "Data wydania",
	"dropzone.inner.info": "Dozwolone pliki: JPEG, PNG, PDF",
	"dropzone.inner.title": "Prześlij swój dokument",
	"error.booking.member_invalid": "Twój profil nie został jeszcze zweryfikowany.",
	"error.booking.no.usage": "Brak użycia dla tych dat rezerwacji",
	"error.booking.no_credit_card": "Najpierw dodaj informacje o karcie kredytowej.",
	"error.booking.same_period": "Masz już zaplanowaną rezerwację na ten okres.",
	"error.change_password.400.bad_request": "Hasło jest niepoprawne",
	"error.contract.inactive": "Usługa nie jest aktywna dla Twojej firmy, skontaktuj się z menedżerem serwisu.",
	"error.contract.not-found": "Dostęp do usługi został zawieszony przez Twoją firmę, skontaktuj się z kierownikiem serwisu.",
	"error.credit.card.refused": "Karta kredytowa odrzucona",
	"error.forgot_password.404": "Sprawdź wpisany adres e-mail, bo nie pasuje do żadnego konta.",
	"error.form.email.already_exists": "Wprowadź inny adres e-mail",
	"error.form.email_invalid": "Podaj prawidłowy adres e-mail",
	"error.form.inviteCode.notEmpty": "Podaj kod zaproszenia",
	"error.form.password.at_least": "Twoje hasło musi zawierać co najmniej 8 znaków",
	"error.form.password.at_most": "Twoje hasło może zawierać maksymalnie 25 znaków",
	"error.form.password.cannot_reset_same": "Twoje nowe hasło musi być inne niż obecne",
	"error.form.password.digit": "Hasło musi zawierać co najmniej 1 cyfrę",
	"error.form.password.lower_letter": "Hasło musi zawierać co najmniej 1 małą literę",
	"error.form.password.upper_letter": "Hasło musi zawierać co najmniej 1 wielką literę",
	"error.form.password_confirmation.the_same": "Wprowadź dwukrotnie to samo hasło",
	"error.form.password_old.the_same": "Nowe hasło musi różnić się od poprzednio używanych haseł",
	"error.form.required": "Wypełnij wszystkie obowiązkowe pola",
	"error.form.suggestion.address.required": "Wybierz adres z listy propozycji",
	"error.form.technical": "Błąd techniczny",
	"error.get.site.config": "Nie udało się załadować konfiguracji witryny",
	"error.invite.code.invalid": "Społeczność, do której chcesz dołączyć, nie istnieje",
	"error.login.401.unauthorized": "Adres e-mail lub hasło jest nieprawidłowe",
	"error.login.403.user.anonymized": "Twoje konto jest anonimizowane, nie możesz już z niego korzystać",
	"error.login.422.user.not.enabled": "Twoje konto nie zostało aktywowane, sprawdź pocztę i postępuj zgodnie z instrukcjami, aby aktywować konto.",
	"error.number.above.max": "Wartość nie może być większa niż {value}",
	"error.number.below.min": "Wartość nie może być mniejsza niż {value}",
	"error.phone.format.invalid": "Format numeru telefonu jest niepoprawny",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Błąd żądania",
	"error.reset_password.401": "Podany link jest już nieaktualny, poproś o kolejne hasło w witrynie",
	"error.search.vehicles.403": "Nie możesz uzyskać dostępu do wybranej witryny z bieżącym aktywnym profilem",
	"error.session.expired": "Sesja wygasła",
	"error.text.length.long": "To pole jest ograniczone do {count} znaków",
	"error.text.length.short": "Minimalna liczba znaków {count}",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Nie można zmienić imienia i nazwiska oraz daty urodzin po zweryfikowaniu profilu.",
	"faq.contactEmailFallback": "kontaktowy adres e-mail",
	"faq.contactPhoneFallback": "Dół strony",
	"faq.other_question": "Nie możesz znaleźć odpowiedzi na swoje pytanie?",
	"file_upload_size_exceeded": "Plik jest zbyt duży. Maksymalny rozmiar: 5 MB",
	"footer.label.legal.information": "Informacje prawne",
	"footer.label.personal.data": "Dane osobiste",
	"footer_callUs": "Zadzwoń do nas",
	"footer_other": "Inne",
	"footer_share": "Śledź nas w mediach społecznościowych",
	"footer_society_about": "O nas",
	"footer_society_policy_privacy": "Polityka prywatności",
	"footer_society_term": "Regulamin",
	"footer_writeUs": "Wyślij e-mail",
	"forgot_password.confirmation": "Link do zresetowania hasła został wysłany na Twój adres e-mail.",
	"forgot_password.description_line1": "Wpisz adres e-mail powiązany z Twoim kontem.",
	"forgot_password.description_line2": "Wyślemy Ci link do zresetowania hasła.",
	"forgot_password.submit": "Wyślij mi link resetowania",
	"generic.address": "Adres",
	"generic.at": "o",
	"generic.book": "Rezerwuj",
	"generic.cancel": "Anuluj",
	"generic.canceled": "Anulowany",
	"generic.city": "Miasto",
	"generic.clear": "Wyczyść",
	"generic.company": "Firma",
	"generic.completed": "Zakończony",
	"generic.country": "Kraj",
	"generic.email": "Adres e-mail",
	"generic.end": "Koniec",
	"generic.expires.at": "Data ważności",
	"generic.extend": "Przedłuż",
	"generic.file": "Plik",
	"generic.first.name": "Imię",
	"generic.last.name": "Nazwisko",
	"generic.location.fixture.label": "Parkingi",
	"generic.location.history.label": "Historia",
	"generic.location.search.placeholder": "Wyszukaj adres, miasto ...",
	"generic.mobile.phone": "Nr telefonu komórkowego",
	"generic.modify": "Zmień",
	"generic.mr": "Pan",
	"generic.mrs": "Pani",
	"generic.next": "Dalej",
	"generic.number": "Numer",
	"generic.passport": "Paszport",
	"generic.past.placeholder": "Znajdziesz tutaj historię swoich rezerwacji",
	"generic.phone.number": "Numer telefonu",
	"generic.postal.code": "Kod pocztowy",
	"generic.retry": "Spróbuj ponownie",
	"generic.save": "Zapisz",
	"generic.send": "Wyślij",
	"generic.start": "Początek",
	"generic.text": "Tekst",
	"generic.today": "Dzisiaj",
	"generic.upcoming": "Nadchodząca",
	"generic.updated": "Zaktualizowano",
	"generic.user": "Użytkownik",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Aby się zarejestrować, wejdź na stronę intranetową swojej firmy – znajdziesz tam link do interfejsu rejestracyjnego. (Możesz też wysłać prośbę o dodanie swojego konta na adres {contactEmail}). Link otrzymasz poprzez e-mail.",
	"helpPage_carSharing_issue1_title": "Jak się zarejestrować?",
	"helpPage_carSharing_issue2_answer": "Hasło można zresetować na stronie internetowej lub w aplikacji mobilnej: na adres e-mail powiązany z danym kontem wysłany zostanie link do ustawienia nowego hasła.",
	"helpPage_carSharing_issue2_title": "Co zrobić, jeśli zapomnę hasła?",
	"helpPage_carSharing_issue3_answer": "W przypadku zgubienia identyfikatora lub otrzymania nowego prosimy o kontakt z infolinią pod numerem {contactPhone} w celu jego zresetowania. Nowy identyfikator nie będzie działać, dopóki nie zostanie zresetowany.",
	"helpPage_carSharing_issue3_title": "Co zrobić, jeśli zgubię swój identyfikator lub otrzymam nowy?",
	"helpPage_carSharing_issue4_answer": "Numer rejestracyjny pojazdu jest podany w wiadomości e-mail oraz wiadomości SMS z potwierdzeniem. Dane pojazdu można też znaleźć na stronie rezerwacji w sekcji Moje rezerwacje.",
	"helpPage_carSharing_issue4_title": "Który samochód został zarezerwowany?",
	"helpPage_carSharing_issue5_answer": "Upewnij się, że data i godzina są prawidłowe – przycisk Start jest dostępny tylko w czasie obowiązywania rezerwacji. W takim wypadku możesz przeciągnąć swój identyfikator przez czytnik kart, aby otworzyć drzwi pojazdu.",
	"helpPage_carSharing_issue5_title": "Dlaczego nie mogę znaleźć przycisku Start?",
	"helpPage_carSharing_issue6_answer": "Jeśli rezerwacja została dokonana, a światło świeci się na zielono, ale nie można otworzyć drzwi, naciśnij przycisk znajdujący się na klamce w drzwiach.",
	"helpPage_carSharing_issue6_title": "Dlaczego świeci się zielone światło, a drzwi nadal są zamknięte?",
	"helpPage_carSharing_issue7_answer": "Po dokonaniu rezerwacji pojazdu można ją zmodyfikować lub anulować, korzystając ze strony internetowej lub aplikacji mobilnej. Jeśli potrzebujesz pomocy, skontaktuj się z infolinią pod numerem telefonu {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Modyfikacja / Anulowanie",
	"helpPage_carSharing_issue8_answer": "Nie możesz przeciągnąć identyfikatora z wyprzedzeniem. Pojazd można otworzyć jedynie w wyznaczonym czasie.",
	"helpPage_carSharing_issue8_title": "Czy mogę przeciągnąć identyfikator z wyprzedzeniem?",
	"helpPage_damages_issue1_answer": "Przed rozpoczęciem rezerwacji prosimy o powiadomienie o uszkodzeniach za pomocą aplikacji mobilnej lub telefonicznie pod numerem {contactPhone}.",
	"helpPage_damages_issue1_title": "Co należy zrobić, jeśli zarezerwowany samochód jest uszkodzony?",
	"helpPage_damages_issue2_answer": "Zachowaj spokój i upewnij się, że nikt nie jest ranny. Obejmuje Cię ochrona ubezpieczeniowa. Jak najszybciej skontaktuj się z infolinią pod numerem telefonu {contactPhone} w celu uzyskania dalszych instrukcji.",
	"helpPage_damages_issue2_title": "Co robić, gdy w trakcie mojej rezerwacji dojdzie do wypadku?",
	"helpPage_subtitle": "W tej sekcji znajdziesz odpowiedzi na najczęściej zadawane pytania.",
	"helpPage_tab_carSharing": "Obsługa",
	"helpPage_tab_damages": "Uszkodzenia",
	"helpPage_tab_vehicles": "Pojazd",
	"helpPage_title": "Najczęściej zadawane pytania (FAQ)",
	"helpPage_vehicles_issue1_answer": "Sprawdź datę i godzinę rezerwacji i upewnij się, że tablica rejestracyjna jest zgodna z podaną w rezerwacji. Następnie ponownie przeciągnij przez czytnik WYŁĄCZNIE swój identyfikator. Upewnij się, że korzystasz z identyfikatora należącego do tej samej osoby, która dokonała rezerwacji i że nie został on zmieniony od czasu poprzedniej rezerwacji. Jeżeli niedawno dokonano jego zmiany, skontaktuj się z działem obsługi klienta, aby dokonać natychmiastowej aktualizacji.",
	"helpPage_vehicles_issue1_title": "Dlaczego pojazd nie daje żadnej reakcji?",
	"helpPage_vehicles_issue2_answer": "Sprawdź datę i godzinę rezerwacji oraz to, czy tablica rejestracyjna jest zgodna z podaną w rezerwacji. Upewnij się, że posiadasz odpowiedni identyfikator (należący do osoby dokonującej rezerwacji).",
	"helpPage_vehicles_issue2_title": "Dlaczego czytnik kart pokazuje tylko czerwone światło?",
	"helpPage_vehicles_issue3_answer": "Jeśli masz rezerwację, a światło jest zielone, ale nie słychać otwierania się drzwi, naciśnij przycisk na drzwiach od strony kierowcy, aby je odblokować.",
	"helpPage_vehicles_issue3_title": "Dlaczego drzwi pozostają zamknięte?",
	"helpPage_vehicles_issue4_answer": "Sprawdź numer rejestracyjny pojazdu, datę i godzinę oraz upewnij się, że masz prawidłowe połączenie z Internetem.",
	"helpPage_vehicles_issue4_title": "Dlaczego nie mogę otworzyć drzwi?",
	"helpPage_vehicles_issue5_answer": "Upewnij się tylko, że silnik jest wyłączony, drzwi i bagażnik właściwie zamknięte, a kluczyki z małym chipem zostały włożone do pudełka w schowku.",
	"helpPage_vehicles_issue5_title": "Dlaczego nie mogę zamknąć pojazdu?",
	"home.header_banner": "W październiku <strong> Renault Mobility </strong> stanie się <strong> Udziałem Mobilize </strong>",
	"home.welcome": "Witamy w {productName}!",
	"home.welcome_solo": "Witamy",
	"how_it_works.step_1": "<span class='bold'>Pobierz aplikację</span> ze sklepu App Store lub Google Play.",
	"how_it_works.step_2": "Uruchom aplikację i <span class='bold'>zarejestruj się</span>, wypełniając formularz.",
	"how_it_works.step_3": "Zrób zdjęcie swojego <span class='bold'>prawa jazdy</span>, swojego <span class='bold'>dokumentu tożsamości</span>, a także <span class='bold'>zrób sobie zdjęcie</span> z dokumentem tożsamości obok twarzy i zapisz je w aplikacji!",
	"how_it_works.step_4": "<span class='bold'>Zarejestruj swoją kartę bankową</span>, aby zarządzać płatnościami za wypożyczanie.",
	"how_it_works.step_5": "<span class='bold'>Potwierdź swój adres e-mail</span>, klikając otrzymany link. <span class='bold'>Sprawdź foldery ze spamem</span>.",
	"how_it_works.step_6": "Po potwierdzeniu rejestracji <span class='bold'>zarezerwuj pojazd</span> w naszej aplikacji lub w witrynie internetowej. W dniu rezerwacji <span class='bold'>Twój smartfon będzie Twoim kluczykiem!</span>",
	"info.account.company.already.linked": "Ta firma jest już połączona z Twoim kontem",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Przełączanie profilu",
	"info.worldpay.return.success": "Załączone informacje dotyczące płatności",
	"iso__BE": "Belgia",
	"iso__CS": "Czechy",
	"iso__DA": "Dania",
	"iso__DE": "Niemcy",
	"iso__ES": "Hiszpania",
	"iso__FR": "Francja",
	"iso__IT": "Włochy",
	"iso__NL": "Holandia",
	"iso__PL": "Polska",
	"iso__PT": "Portugalia",
	"iso__SL": "Słowenia",
	"iso__SV": "Szwecja",
	"iso__pt_BR": "Brazylia",
	"label.accept_terms_and_conditions": "Wyrażam zgodę na kontakt z firmą Renault i jej partnerami za pośrednictwem poczty elektronicznej w celu przeprowadzenia badania lub informacji o nowych produktach, jak również aktualnych ofert. Przy okazji każdego wysłania będę miał(-a) możliwość zakończenia całej komunikacji.",
	"label.account.already.active": "Twoje konto jest już aktywne",
	"label.account_activation_description": "Otrzymasz potwierdzenie e-mailem, gdy Twoje konto zostanie zweryfikowane i będzie możliwe korzystanie z usługi w pełni.",
	"label.account_activation_title": "Gratulacje, sfinalizowałeś subskrypcję. Twoje konto zostanie niezwłocznie sprawdzone!",
	"label.activation.link.expired": "Link aktywacyjny wygasł",
	"label.activation.link.send": "Wyślij ponownie",
	"label.activation.link.sent.success": "Wiadomość z łączem aktywacyjnym zostanie wysłana, jeśli użytkownik istnieje, a konto nie jest aktywowane",
	"label.active.profile": "Aktywny profil",
	"label.actual.payment.method": "Twoja bieżąca metoda płatności",
	"label.add.new.profile": "Dodaj nowy profil",
	"label.apply": "Zastosuj",
	"label.are_you_sure_you_want_to_cancel": "Czy chcesz potwierdzić anulowanie?",
	"label.birth.day": "Data urodzenia",
	"label.booking": "Rezerwować",
	"label.booking.past": "Przeszła",
	"label.booking.past.placeholder": "Tutaj znajdziesz swoją historię rezerwacji.",
	"label.booking.today.part": "dzisiaj o",
	"label.booking.upcoming.placeholder": "Znajdź tutaj swoje zaplanowane i trwające rezerwacje",
	"label.cancel_my_booking": "Anuluj moją rezerwację",
	"label.car": "pojazd",
	"label.carSharing": "Udostępnianie samochodu",
	"label.cars": "pojazdy",
	"label.civility": "Stan cywilny",
	"label.click_here": "Kliknij tutaj",
	"label.close": "Zamknij",
	"label.confirm_new_password": "Potwierdź hasło",
	"label.congratulations": "Gratulacje!",
	"label.continue": "Kontynuuj",
	"label.creditCard_message": "W celu zweryfikowania Twojej karty zostanie dokonane tymczasowe obciążenie. Na koncie powiązanym z Twoją kartą może tymczasowo pojawić się debet w wysokości {amountToTake} EUR. Jeśli obciążenie utrzymuje się dłużej niż pięć dni roboczych, skontaktuj się ze swoim bankiem.",
	"label.date": "Data",
	"label.delivery_place": "Miasto wydania",
	"label.driving_licence": "Prawo jazdy",
	"label.driving_licence_back": "Prawo jazdy (tył)",
	"label.driving_licence_front": "Prawo jazdy (przód)",
	"label.edit.invite.code": "Edytuj kod zaproszenia",
	"label.expiration_date": "Data ważności",
	"label.file.upload.only.mobile": "Aby edytować dokumenty, skorzystaj z aplikacji mobilnej.",
	"label.filter_by": "Filtruj według",
	"label.filters": "Filtry",
	"label.generic.error": "Wystąpił błąd. Spróbuj ponownie później.",
	"label.hours": "godz.",
	"label.how_it_works": "Jak to działa?",
	"label.identity.card": "Dowód tożsamości",
	"label.identity.document.number": "Numer dokumentu tożsamości",
	"label.identity.document.type": "Typ dokumentu tożsamości",
	"label.identity_card": "Dokument tożsamości",
	"label.identity_card_back": "Dokument tożsamości (tył)",
	"label.identity_card_front": "Dokument tożsamości (przód)",
	"label.identity_card_selfie": "Selfie z dokumentem tożsamości",
	"label.invite_code_placeholder": "Wpisz swój kod zaproszenia",
	"label.italy.fiscal.code": "Wprowadź numer fiskalny",
	"label.italy.resident": "Czy jesteś Włochem?",
	"label.licence_number": "Seria i numer blankietu z prawa jazdy (pod kodem kreskowym)",
	"label.load_more": "Więcej wyników",
	"label.login": "Zaloguj się",
	"label.logout": "Wyloguj się",
	"label.manager.email": "E-mail twojego kierownika",
	"label.mandatory_fields": "* Pola obowiązkowe",
	"label.member_already": "Masz już członkostwo?",
	"label.my_account": "Moje konto",
	"label.my_reservations": "Moje rezerwacje",
	"label.new.password": "Nowe hasło",
	"label.no_account": "Chcesz dołączyć?",
	"label.or_by_phone": "Lub telefonicznie",
	"label.password": "Hasło",
	"label.password_forgot": "Nie pamiętam hasła",
	"label.phone": "Nr telefonu",
	"label.phone.suffix": "Sufiks numeru telefonu",
	"label.plateNumber": "Numer rejestracyjny",
	"label.price": "Cena",
	"label.redirectMobileApp": "Aby rozpocząć rezerwowanie, pobierz naszą aplikację mobilną!",
	"label.remember_me": "Nie wylogowuj mnie",
	"label.reset_password_done": "Twoje hasło zostało zaktualizowane",
	"label.return": "Wstecz",
	"label.schedule": "Godziny",
	"label.search": "Szukaj",
	"label.selected.language": "Wybrany język",
	"label.subject": "Temat",
	"label.switch.profile": "Przełącz profil",
	"label.the": "do",
	"label.validate": "Zweryfikuj",
	"label.vehicles_found": "Znalezione wyniki: {count}",
	"label.warning": "Ostrzeżenie",
	"label.welcome.finish.registration": "Aby potwierdzić wizytę, zakończ rejestrację.",
	"label.you_are_trying_to_cancel_your_booking": "Masz zamiar anulować rezerwację!",
	"label.your.active.profile": "Twój aktywny profil",
	"label.your.other.profiles": "Twoje inne profile",
	"label.your_message": "Twoja wiadomość",
	"language.header": "Wybierz język",
	"login.forgot_password": "Nie pamiętasz hasła?",
	"login.register": "Zarejestruj się",
	"menu.faq": "Informacje",
	"mobile_banner.text": "Pobierz aplikację {productName}",
	"page.password.update.sub.title": "Ze względów bezpieczeństwa prosimy o aktualizację hasła",
	"page.password.update.title": "Aktualizacja hasła",
	"parking.special_opening_legend": "Specjalne godziny otwarcia",
	"part.company.fill.extra.info": "prośba o uzupełnienie dodatkowych informacji.",
	"part.complete.register.for": "Dokończ rejestrację:",
	"part.create.account.for": "Utwórz konto dla",
	"part.link.account.to": "Połącz swoje konto z",
	"part.your.email": "twój e-mail",
	"placeholder.enter.number": "Wprowadź liczbę ...",
	"placeholder.enter.text": "Pisz tutaj ...",
	"placeholder.search": "Szukaj ...",
	"profile.422.error.info": "Wygląda na to, że w Twoim profilu brakuje niektórych informacji.\n Wspólnie zweryfikujmy Twój profil, aby upewnić się, że wszystko jest w porządku.",
	"profile.info.new.email": "Jeśli zaktualizujesz adres e-mail, otrzymasz wiadomość e-mail w celu zweryfikowania adresu. Bez weryfikacji nie będzie można dokonać rezerwacji.",
	"profile.label.before.arrival": "Przed przyjazdem",
	"profile.label.before.departure": "Przed wyjazdem",
	"profile.label.charges.call.center": "Zmiany dokonane w moim imieniu",
	"profile.label.charges.my": "Zmiany dokonane przeze mnie",
	"profile.label.current.password": "Aktualne hasło",
	"profile.label.expiration.date.status": "Moje prawo jazdy nie ma daty ważności",
	"profile.label.min.15": "15 minut",
	"profile.label.min.30": "30 minut",
	"profile.label.min.45": "45 minut",
	"profile.label.new.email": "Nowy adres e-mail",
	"profile.label.street.field": "Adres (numer domu + nazwa ulicy)",
	"profile.label.validated.email": "Zweryfikowany adres e-mail",
	"profile.section.additional.info": "Dodatkowe informacje",
	"profile.section.credentials": "Aktualizacja hasła",
	"profile.section.language": "Język profilu",
	"profile.section.notifications": "Powiadomienia i alerty",
	"profile.section.payment.info": "Informacje o płatności",
	"profile.section.personal.info": "Informacje osobiste",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Dostęp dla technika",
	"profile.select.menu.item": "Wybierz pozycję menu po lewej stronie",
	"profile.selfie.section.info": "Zrób sobie zdjęcie, pokazując przy twarzy dowód tożsamości.",
	"profile.suspended": "Twój profil jest zawieszony",
	"profile.title.email.notifications": "Powiadomienia e-mail",
	"profile.title.language.select": "Język używany w powiadomieniach i e-mailach",
	"profile.title.sms.notifications": "Powiadomienia SMS",
	"profile.title.update.email": "Zaktualizuj adres e-mail",
	"profile.title.update.password": "Zaktualizuj hasło",
	"profile_error_driver_license_invalid": "Prawo jazdy jest nieważne",
	"register.field.info.password": "Musi zawierać co najmniej 1 cyfrę, 1 wielką literę, 1 małą literę i od 8 do 25 znaków",
	"register.info.payment.saved": "Metoda płatności została zapisana.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Link aktywacyjny został wysłany na {email}. Sprawdź pocztę i folder ze spamem, a następnie postępuj zgodnie z instrukcjami, aby aktywować konto, zanim łącze wygaśnie.",
	"register.terms.ads": "Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych (zarówno metodami zautomatyzowanymi, jak i tradycyjnymi) w odniesieniu do produktów i/lub usług mobilności",
	"register.terms.prefix.accept": "Akceptuję",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "polityka prywatności",
	"register.terms.root.tos": "Warunki subskrypcji",
	"register.terms.root.tou": "Regulamin",
	"register.terms.suffix.ads": "wykorzystanie moich danych w celach komercyjnych",
	"register.terms.suffix.of": "z",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Gratulacje {firstName}, Twoje konto zostało utworzone",
	"register.title.account.linked": "Gratulacje {firstName}, nowy profil został połączony z Twoim kontem",
	"register.title.account.updated": "Gratulacje {firstName}! Twoje konto zostało zaktualizowane",
	"reset_password.title": "Resetowania hasła",
	"search.filter_alphabetically": "Alfabetycznie",
	"search.filter_by": "Sortuj według",
	"search.filter_by_price": "Według ceny",
	"search.result.empty": "Nie ma rezultatu",
	"service.corporate.intro": "Chcesz dołączyć do społeczności? Wprowadź kod zaproszenia.",
	"service.intro_label": "Z której usługi {productName} chcesz korzystać?",
	"service.private.intro": "Chcesz zarezerwować pojazd z sieci {productName}?",
	"service.private.renaultfr": "Aby zasubskrybować {productName}, pobierz aplikację ze swojego sklepu z aplikacjami.",
	"service.private.select_country": "Wybierz kraj",
	"service.usage.corporate": "Carsharing firmowy",
	"service.usage.private": "Wynajem samochodów 24/7",
	"service.usage.vr": "Pojazd zastępczy",
	"service.vr.intro": "Dziękujemy za zainteresowanie naszymi usługami! \n\n Aby dołączyć, skontaktuj się ze sprzedawcą i odbierz link rejestracyjny.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Wpisz swój służbowy adres e-mail",
	"sso.login.title": "Połącz z jednokrotnym logowaniem",
	"status.APPROVED": "Profil zweryfikowany",
	"status.NOT_APPROVED": "Twój profil został odrzucony. Zaktualizuj swój profil.",
	"status.TO_COMPLETE": "Niekompletny",
	"status.TO_REVIEW": "Twój profil oczekuje na weryfikację",
	"tagline": "Samoobsługowa wypożyczalnia samochodów 24/7",
	"title.add.payment.later": "Możesz to dodać później.",
	"title.add.payment.method": "Dodaj metodę płatności.",
	"title.bookings.welcome.tutorial": "Znajdź tutaj swoją rezerwację, jest już zaplanowana",
	"title.modify.booking": "Zmień moją rezerwację",
	"title.password.change.success": "Nowe hasło zostało zapisane",
	"title.update.booking": "Zaktualizuj rezerwację",
	"title.welcome.to.brand": "Witaj {firstName}, witaj w {brandName}.",
	"title.welcome.to.program": "Witaj {firstName}, witaj w programie {brandName} {program}.",
	"vehicle.incorrect.usage": "Pojazd nie jest dostępny do tego typu użytkowania",
	"week.day.friday": "Piątek",
	"week.day.monday": "Poniedziałek",
	"week.day.saturday": "Sobota",
	"week.day.sunday": "Niedziela",
	"week.day.thursday": "Czwartek",
	"week.day.tuesday": "Wtorek",
	"week.day.wednesday": "Środa"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/pl.json
 ** module id = 426
 ** module chunks = 0
 **/